import type { FC } from 'react'

import LabelText from '../LabelText'

interface LessonLabelProps {
  courseNumber: number
  lessonNumber: number
  numberOfLessons?: number
}

const LessonLabel: FC<LessonLabelProps> = ({ courseNumber, lessonNumber, numberOfLessons }) => {
  return (
    <LabelText courseNumber={courseNumber}>
      Lesson {lessonNumber}
      {numberOfLessons && ` of ${numberOfLessons}`}
    </LabelText>
  )
}

export default LessonLabel
